export default "__VITE_ASSET__3eUU4_gj__"